var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.818,
    height: 23.191,
    viewBox: "0 0 29.818 23.191",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-comments",
    "data-name": "Icon awesome-comments",
    d: "M21.535,10.533c0-4.576-4.819-8.283-10.767-8.283S0,5.956,0,10.533A7.023,7.023,0,0,0,1.967,15.3,11.652,11.652,0,0,1,.114,18.116a.412.412,0,0,0-.078.45.405.405,0,0,0,.378.248,9.115,9.115,0,0,0,4.592-1.294,13.172,13.172,0,0,0,5.762,1.294C16.715,18.815,21.535,15.109,21.535,10.533ZM27.85,21.921a7.013,7.013,0,0,0,1.967-4.763c0-3.463-2.77-6.429-6.693-7.667a7.693,7.693,0,0,1,.067,1.041c0,5.482-5.575,9.939-12.424,9.939a15.52,15.52,0,0,1-1.641-.1c1.631,2.977,5.461,5.068,9.924,5.068a13.1,13.1,0,0,0,5.762-1.294A9.115,9.115,0,0,0,29.4,25.441a.408.408,0,0,0,.378-.248.415.415,0,0,0-.078-.45A11.528,11.528,0,0,1,27.85,21.921Z",
    transform: "translate(0 -2.25)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComments);
export default __webpack_public_path__ + "static/media/comments.3d3b83d301eb086ef3c1d08b9ea76634.svg";
export { ForwardRef as ReactComponent };